import upsell from "../upsell"
import apiDietPaymentProcessor from "../apiDietPaymentProcessor"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"

export default (getView) => (nextStepPath, successStepPath, failedStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("premium"),

  isPaymodeModalNeeded: false,
  isPaymodeModalOpen: false,
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.commonInit()

    if (
      !this.store.values.lastPaymentMethod ||
      this.store.values.lastPaymentMethod !== "primer" ||
      !this.store.values.isCardSaved
    ) {
      this.isPaymodeModalNeeded = true
    }
  },

  onInit() {
    this.initUpsell()
  },

  handlePayment(paymode) {
    const { handleCheckoutAndRedirect } = apiDietPaymentProcessor

    // Handle card-save payments
    if (!paymode && !this.isPaymodeModalNeeded) {
      this.loading = true
      const paymentParamsCardSave = {
        successStepPath,
        failedStepPath,
        paymentMethod: "primer",
        restrictCardSave: false,
        checkoutTemplate: "cf-ac-pipe",
      }

      this.internalTracker.trackClick({ clickName: "Premium Accepted Clicked" })
      handleCheckoutAndRedirect(paymentParamsCardSave)
      return
    }
    // Open up modal if there is no paymode
    if (!paymode && this.isPaymodeModalNeeded) {
      this.internalTracker.trackClick({ clickName: "Premium Accepted Clicked" })
      this.isPaymodeModalOpen = true

      return
    }

    const trackingEventNames = {
      primer: "Credit Card Submitted",
      google_pay: "Google Pay Selected",
      apple_pay: "Apple Pay Selected",
      paypal_recurring: "PayPal Selected",
    }
    this.internalTracker.trackClick({ clickName: trackingEventNames[paymode] || paymode })
    // Handle payments that doesn't have save-card
    this.store.values.lastPaymentMethod = paymode
    this.loading = true
    const paymentParamsWithoutCardSave = {
      successStepPath,
      failedStepPath,
      paymentMethod: paymode,
      restrictCardSave: true,
      checkoutTemplate: "cf-ac-pipe",
    }

    handleCheckoutAndRedirect(paymentParamsWithoutCardSave)
  },

  handleModalClose() {
    this.internalTracker.trackClick({ clickName: "Close Modal Clicked" })
    this.isPaymodeModalOpen = false
  },

  handleOfferDecline() {
    this.internalTracker.trackClick({ clickName: "Premium Rejected Clicked" })
    this.goToNextUpsellOffer(true)
  },
})
